import React from "react";
import Scrollbar from "react-scrollbars-custom";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import "assets/scss/partials/microsoftTeams.scss";
import ManageSurvey from "views/Survey/ManageSurvey";

export default ({ dialog, setDialog }) => {

	return (
		<>
			<Modal
				open={dialog}
				closeOnOverlayClick={false}
				onClose={() => setDialog(false)}
				showCloseIcon={false}
				center={true}
				classNames={{ modal: "microsoftTeamUserPollListDetail" }}
				closeOnEsc={false}
			>
				<div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
					{" "}
					Manage Survey
					<div className="closeMicrosoftTeamsDialog">
						<CloseIcon onClick={() => setDialog(false)} className="cursor" />
					</div>
				</div>
				<div className="pollListContent">
					<Scrollbar style={{ height: "calc(100vh - 100px)" }}>
						<div>
							<div>
								<ManageSurvey />
							</div>
						</div>
					</Scrollbar>
				</div>
			</Modal>
		</>
	);
};
